import { SourcesByVehicle, Vehicle } from '../types'

const BASE_URL = 'services/plugin-cameras/cameras'

export class HttpError extends Error {
    status: number

    constructor(message: string, status: number) {
        super(message)
        this.name = 'HttpError'
        this.status = status
    }
}

export const fetchVehicles = async (): Promise<Vehicle[]> => {
    const response = await fetch(`${BASE_URL}/vehicles`)

    if (!response.ok) {
        throw new Error(`Failed to fetch vehicles: ${response.status}`)
    }

    return response.json()
}

export const fetchSources = async (sourceIds: string[]): Promise<SourcesByVehicle> => {
    const response = await fetch(`${BASE_URL}/sources`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(sourceIds),
    })

    if (!response.ok) {
        throw new Error(`Failed to fetch sources: ${response.status}`)
    }

    return response.json()
}

export const startLiveStream = async (sourceId: string): Promise<void> => {
    const response = await fetch(`${BASE_URL}/video/${encodeURIComponent(sourceId)}/live/start`, {
        method: 'POST',
    })

    if (!response.ok) {
        throw new HttpError(`Failed to start live stream: ${response.status}`, response.status)
    }
}
